import { createWebappRoute, getCurrentRouteParams } from '../helpers';

export default [
  // "mapfullscreen": "showFullMap",
  createWebappRoute({
    path: '/mapfullscreen',
    name: 'mapfullscreen-module',
    component() {
      console.log('ROUTER, showFullMap');

      if (DP.map && DP.map.objMap) {
        DP.map.objMap.ui.fullscreen.full();
      }

      return {};
    },
  }),

  // "mapfullscreen/:lon/:lat": "showFullMapAndGoto",
  createWebappRoute({
    path: '/mapfullscreen/:lon/:lat',
    name: 'mapfullscreen-module-lon-lat',
    component() {
      console.log('ROUTER, showFullMapAndGoto');
      const { lon, lat } = getCurrentRouteParams();

      if (DP.map && DP.map.objMap) {
        DP.map.objMap.ui.fullscreen.full();
        DP.map.goToLocation(lon, lat);
      }

      return {};
    },
  }),

  // 'map/:id': 'showLargeMap',
  createWebappRoute({
    path: '/map/:id',
    name: 'map-module',
    component() {
      console.log('ROUTER, showLargeMap');

      const { id } = getCurrentRouteParams();

      if ($dtw.vwDetailWorkplace) {
        $dtw.vwDetailWorkplace.showById(id);
      } else {
        document.location.hash = 'home';
      }

      return {};
    },
  }),

  // 'map/area/:id': 'showLargeMapArea',
  createWebappRoute({
    path: '/map/area/:id',
    name: 'map-module-area',
    component() {
      console.log('ROUTER, showLargeMapArea');

      const { areaId } = getCurrentRouteParams();

      if ($dtw.vwDetailWorkplace) {
        $dtw.vwDetailWorkplace.showArea(areaId);
      } else {
        document.location.hash = 'home';
      }

      return {};
    },
  }),
];
